// extracted by mini-css-extract-plugin
module.exports = {"content":"Description_content__1FKfs","columns":"Description_columns__1Lhbv","submitBtn":"Description_submitBtn__3pRcA"};